var isVisible = false
export var scroll = $('#scroll--top_JS').click(function(){
		$('body, html').animate({
			scrollTop: '0px'
		}, 300);
	});
	$('#scroll--top_JS').slideUp('fast');
	$(window).scroll(function(){
		if( $(this).scrollTop() >=180 && !isVisible ){
			$('#scroll--top_JS').show();
			isVisible = true
		}  
		if( $(this).scrollTop() <=180 && isVisible )	{
			$('#scroll--top_JS').hide();
			isVisible = false
		}
	});



// WEBPACK FOOTER //
// ./resources/assets/js/scroll-top.js